module.exports = __webpack_public_path__ + "img/logo.0edebb38.png";